export const NEW_NOTIFICATION = 'SYSTEMNOTIFICATION/NEW'
export const REMOVE_NOTIFICATION = 'SYSTEMNOTIFICATION/REMOVE'
export const UNSHIFT_NOTIFICATION = 'SYSTEMNOTIFICATION/UNSHIFT'
export const POP_NOTIFICATION = 'SYSTEMNOTIFICATION/POP'
